import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { optionDescription } from '../../../shared/styles/option.vanilla.mjs';

const SingleSelectOptionDescription = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = classNames(optionDescription, classNameFromProps);
  return /* @__PURE__ */ jsx(
    Primitive.p,
    {
      "data-scope": "single-select",
      "data-part": "option-description",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});

export { SingleSelectOptionDescription as SelectOptionDescription };
//# sourceMappingURL=OptionDescription.mjs.map
